import { render, staticRenderFns } from "./DashboardCli.vue?vue&type=template&id=5478fc5c&scoped=true"
import script from "./DashboardCli.vue?vue&type=script&lang=js"
export * from "./DashboardCli.vue?vue&type=script&lang=js"
import style0 from "./DashboardCli.vue?vue&type=style&index=0&id=5478fc5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5478fc5c",
  null
  
)

export default component.exports